<script setup>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import setTooltip from "@/assets/js/tooltip.js";

import DataTables from "./components/DataTables.vue";
import CensadoPieChart from "./components/CensadoChart.vue";
import StackBarChart from "./components/StackBarChart.vue";
const store = useStore();
const totalCensado = ref(0);

if (window.innerWidth <= 768) {
  // Ajusta el navbar si el ancho de la pantalla es menor o igual a 768px
  store.commit("navbarMinimize");
}

onMounted(() => {
  setTooltip(store.state.bootstrap);
  store.commit("navbarMinimize");
});

const handlePercentageUpdate = (data) => {
  totalCensado.value = data.total;
};
</script>
<template>
  <div class="p-3 py-md-4 p-lg-4 container-fluid">
    <div class="row">
      <div class="col-lg-7 col-md-12 mt-lg-0">
        <stack-bar-chart />
      </div>
      <div class="col-lg-5 col-md-12 mt-lg-0 mt-4">
          <div class="card h-100">
            <div class="p-3 card-header">
              <div class="d-flex justify-content-between">
                <h6 class="mb-0">Número de Electores Censados</h6>
                <div
                  v-if="isLoading"
                  class="spinner-border text-primary"
                  role="status"
                ></div>
              </div>
            </div>
            <div class="p-3 card-body">
              <div class="row flex-column flex-md-row">
                <div class="col-md-12 mb-4 mb-md-0">
                  <CensadoPieChart :provinceId="provinceId" @percentageUpdate="handlePercentageUpdate" />
                </div>                  
              </div>   
              <hr class="my-2">
              <div class="row">
                <div class="col-md-12 align-center justify-content-center d-flex">
                  <p class="mt-0 mb-0">Total de registros: {{ totalCensado.toLocaleString() }} </p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>

    <div class="mt-4 row">
      <div class="col-sm-12">
        <data-tables key="" :applyFilters="false" />
      </div>
    </div>
  </div>
</template>

<style>
div.row {
  --bs-gutter-x: 1.5rem;
}
</style>